export const LIMIT_CHARS = 60000

export const tippyOptions = {
  duration: 300, // Millisecond
  delay: 300 // Millisecond
}

export const EDIT_IMAGE_SIZE = '7.688rem'
export const MEDIA_MARGIN_TOP = '1.5rem'
export const URL_MARGIN_BOTTOM = '1rem'
export const EDIT_VIDEO_SIZE = '10.188rem'
export const EDIT_URL_SIZE = '6.25rem'

export const postElementsHeight = {
  default: {
    MODAL_BACK_DROP: '10.188rem',
    HEADER_SIZE: '4.237rem',
    TITLE_SIZE: '5.375rem',
    COUNTER_SIZE: '4.125rem',
    ACTIONS_SIZE: '4.75rem',
    ACTIONS_OPEN_UPLOAD_SIZE: '22.188rem',
    ACTIONS_FILE_UPLOADED_SIZE: '11.25rem',
    ACTIONS_VIDEO_SIZE: '16.396rem',
    FOOTER_SIZE: '5.625rem'
  },
  fullscreen: {
    HEADER_SIZE: '5rem',
    TITLE_SIZE: '5.375rem',
    COUNTER_SIZE: '4.625rem',
    ACTIONS_SIZE: '5.75rem',
    ACTIONS_OPEN_UPLOAD_SIZE: '20.188rem',
    ACTIONS_FILE_UPLOADED_SIZE: '11.688rem',
    ACTIONS_VIDEO_SIZE: '15.719rem',
    FOOTER_SIZE: '5.625rem'
  }
}
